import Modal, { ModalSize } from "../../../../common/components/Modal";
import GridGappedContainer, {
  GridGappedContainerSize,
} from "../../../../common/components/GridGappedContainer/GridGappedContainer";
import AtcProductInfo from "../../addToCart/AtcProductInfo";
import { useAddToCartWizardContext } from "../AddToCartWizard";
import { Alert } from "~/common/m3/Alert/Alert";
import type { ProductDescriptor } from "~/feature/ProductDescriptor/v1/types";

interface Props {
  productDescriptor: ProductDescriptor;
}

export const ErrorLoadingModal = ({ productDescriptor }: Props) => {
  const { t, getModalProps, getMainCls, getCloseBtn, closePopup } = useAddToCartWizardContext();
  const modalProps = getModalProps();
  const mainCls = getMainCls();

  return (
    <Modal size={ModalSize.MEDIUM} onClose={closePopup} footerChildren={getCloseBtn(t("close"))} {...modalProps}>
      <div className={mainCls}>
        <div className="scha__atc-popup--column-info">
          <AtcProductInfo
            descriptor={productDescriptor}
            quantity={null}
            price={null}
            priceUnit={1}
            onChange={() => {}}
            disabled={true}
            priceReference={""}
          />
        </div>
        <div className="scha__atc-popup--column-packaging">
          <Alert severity="error" className="scha-atc__delivery-disclaimer no-bottom">
            {t("addProduct.wsError")}
          </Alert>
        </div>
      </div>
    </Modal>
  );
};
